import React from "react";

import { IconMainMenuAnalytics } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { ANALYTICS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const AnalyticsIndexBreadcrumb = () => {
	const link = useNavigateToLink(ANALYTICS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<BreadcrumbLayout icon={<IconMainMenuAnalytics className={BREADCRUMB_ICON_CLASS} />} label="Analytics" to={link} />
	);
};

AnalyticsIndexBreadcrumb.PATH = ANALYTICS_PATH;
